import { createAction, props } from '@ngrx/store';
import {
  CaseEntityAppEntityCaseEntityItemRead,
  CaseEntityAppEntityCaseEntityRead, ShipmentAppEntityShipmentItemRead
} from '../../openapi';

export const loadMyCaseList = createAction('[MyCases] load my case list');

export const loadMyCaseListSuccess = createAction(
  '[MyCases] load my case list success', props<{ cases: CaseEntityAppEntityCaseEntityRead[] }>()
);

export const loadMyCaseListFailure = createAction('[MyCases] load my case list failure');

export const loadCaseItem = createAction('[MyCases] load my case item', props<{ id: string; }>());

export const loadCaseItemSuccess = createAction('[MyCases] load my case item success', props<{
  caseItem: CaseEntityAppEntityCaseEntityItemRead
}>());

export const loadCaseItemFailure = createAction('[MyCases] load my case item failure');

export const loadShipmentItem = createAction('[MyCases] load shipment item', props<{ id: string }>());

export const loadShipmentItemSuccess = createAction('[MyCases] load shipment item success', props<{
  shipment: ShipmentAppEntityShipmentItemRead
}>());

export const loadShipmentItemFailure = createAction('[MyCases] load shipment item failure');
